import React, { useEffect } from "react";
import { Field, reduxForm } from "redux-form";
import Titlebanner from "../../../globel_cmponents/title_banner";
import { Button, Card, CardBody, Col, Row } from "reactstrap";
import RenderField from "../../formcomponent/formfields/RenderField";
import axios from "axios";
import requests from "../../../utils/Requests";
import { useHistory, useParams } from "react-router-dom";
import Swal from "sweetalert2";
const CreateMealsHotels = (props) => {
  const { handleSubmit } = props;
  const history = useHistory();
  const { id } = useParams();
  useEffect(() => {
    if (id != "null") {
      getMealHotelDetails();
    }
  }, [id]);

  const getMealHotelDetails = async () => {
    await axios
      .post(requests.getMealHotel, { mealHotelId: id })
      .then((res) => {
        console.log(res.data);
        props.initialize({
          ...res.data
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const postToApi = async (values) => {
    console.log(values);

    await axios
      .post(requests.createMealHotel, values)
      .then((res) => {
        console.log(res.data);
        Swal.fire("success", "Hotel Added", "success");
        history.push("/Meals/MealsHotellist/mealse-hotel-list");
      })
      .catch((error) => {
        console.log(error);
      });
  };
  return (
    <div>
      <Titlebanner title="Create Meals Hotels" />

      <Card>
        <CardBody>
          <Row>
            <Col>
              <Field name="hotelName" label="Hotel Name" component={RenderField.RenderTextField} />
            </Col>
            <Col>
              <Field
                name="description"
                label="Description"
                type="textarea"
                rows="4"
                component={RenderField.RenderTextareaField}
              />
            </Col>
          </Row>

          <Row>
            <Col>
              <Field name="longitude" label="Longitude" component={RenderField.RenderTextField} />
            </Col>
            <Col>
              <Field name="latitude" label="Latitude" component={RenderField.RenderTextField} />
            </Col>
            <Col>
              <Field name="address" label="Address" component={RenderField.RenderTextField} />
            </Col>
          </Row>
          <div className="float-right">
            <Button
              color="primary"
              onClick={handleSubmit((values) =>
                postToApi({
                  ...values,
                  pill: 1
                })
              )}>
              Create
            </Button>
          </div>
        </CardBody>
      </Card>
    </div>
  );
};

export default reduxForm({
  form: "createMealsHotels"
})(CreateMealsHotels);